/**
 * Every mutation in every app is attributed to an Actor — a human or an
 * agent acting on a human's behalf. Agents are first-class workspace
 * members with their own identity and a permission grant, never an
 * anonymous caller impersonating their human.
 */
const SCOPE_RANK = {
    read: 0,
    triage: 1,
    write: 2,
    full: 3,
};
export function isToolAllowed(toolName, registry, actor) {
    if (actor.kind === "human")
        return true;
    const required = registry[toolName];
    if (required === undefined)
        return false; // unknown tools are denied by default
    if (actor.grant.deniedTools?.includes(toolName))
        return false;
    return SCOPE_RANK[actor.grant.scope] >= SCOPE_RANK[required];
}
export function resolveToolNames(registry, actor) {
    return Object.keys(registry).filter((name) => isToolAllowed(name, registry, actor));
}
